import { Col, Row, Pagination } from 'antd';
import classNames from 'classnames/bind';
import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { SVGS } from '~/assets/assetsPath';
import styles from './HistoryUseCard.module.scss';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import packAPI from '~/api/PackAPI';
import moment from 'moment';
import { saveAs } from 'file-saver';
import { getNumberWithCommas } from '~/utils';

const cx = classNames.bind(styles);

const PaginationCustom = styled.div`
    .ant-pagination-options {
        display: none;
    }
`;

const HistoryUseCard = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isLoading, setIsLoading] = useState(false);
    const userInfo = useSelector((state) => state.user.userInfo);
    const [myUseCard, setMyUseCard] = useState([]);
    const [isShowShare, setIsShowShare] = useState(false);
    const router = location?.search?.split('?').join('') || '';
    const userId = new URLSearchParams(router)?.get('user_id');

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_item: 0,
        total_page: 0,
    });
    const handleGetMyUserCard = async (page) => {
        try {
            setIsLoading(true);
            let cards = [];
            const params = {
                fields: '["$all", {"user": ["$all"]}, {"owner": ["$all"]}]',
                filter: `{"$and": [{"owner_id": "${userInfo?.id}"}, {"user_id": "${userId}"}]}`,
                order: '[["date_submit_pack_unix", "DESC"]]',
                // limit: pagination.limit,
                // page: page,
            };
            const res = await packAPI.getListPackAPI_HistoryUserUsing(userInfo?.id, params);

            if (res.code === 200) {
                cards = res.results.objects.rows.map((item, index) => ({
                    key: index,
                    ...item,
                }));
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / pagination.limit),
                });
            }
            setIsLoading(false);
            setMyUseCard(cards);
        } catch (err) {
            console.log(err);
            setIsLoading(false);
        }
    };
    const handleChangePage = (page) => {
        setPagination({ ...pagination, page });
        handleGetMyUserCard(page);
        window.scrollTo(0, 0);
    };

    const handleSaveQRCode = (image) => {
        saveAs(image, `qr-code-booking-${moment().valueOf()}.png`);
    };

    useEffect(() => {
        handleGetMyUserCard(pagination.page);
        //eslint-disable-next-line
    }, []);

    const mountRef = useRef(true);
    useEffect(() => {
        if (mountRef.current) {
            mountRef.current = false;
            return;
        }
        const script = document.createElement('script');

        script.src = 'https://sp.zalo.me/plugins/sdk.js';

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [isShowShare]);

    console.log('myUseCard', myUseCard);
    return (
        <div className={cx('wrapper_mb')}>
            <div className={cx('title_header')}>
                <Row className={cx('header_row')}>
                    <Col>
                        <Row>
                            <img
                                src={SVGS.ImageChevronLeft}
                                alt="icon chevron left"
                                className={cx('btn_search')}
                                onClick={() => navigate(-1)}
                            />
                            <span className={cx('header_title')}>Tag history</span>
                        </Row>
                    </Col>
                </Row>
            </div>
            <div className={cx('container_card')}>
                {myUseCard.length > 0 &&
                    myUseCard.map((item, index) => {
                        return (
                            <div key={index} className={cx('item_card')}>
                                <p className={cx('title')}>Top up card</p>
                                <Row className={cx('content')}>
                                    <Col>
                                        <span>Value: </span>
                                        <span>{getNumberWithCommas(item?.value)} d</span>
                                    </Col>
                                    <Col className={cx('time')}>
                                        <span>At: </span>
                                        <span>{moment(+item?.date_submit_pack_unix).format('HH:mm DD/MM/YYYY')}</span>
                                    </Col>
                                </Row>
                            </div>
                        );
                    })}
                {myUseCard?.length ? (
                    <Row justify="center" style={{ margin: '30px 0' }}>
                        <PaginationCustom>
                            <Pagination
                                defaultCurrent={1}
                                current={pagination?.page}
                                total={pagination?.total_item}
                                pageSize={pagination?.limit}
                                onChange={handleChangePage}
                            />
                        </PaginationCustom>
                    </Row>
                ) : null}
            </div>
        </div>
    );
};

export default HistoryUseCard;
